import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { PriceFilteringAction } from '../priceFiltering.action';
import { PriceFilteringTranslator } from '../priceFiltering.translator';

type IDependencies = IClientApiDependencySegment;

export const updatePriceFilteringProfileEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(PriceFilteringAction.update.started),
  mergeMap((params) => {
    const { reject } = params;

    return dependencies.api.updatePriceFilteringProfile(PriceFilteringTranslator.toApi(params)).pipe(
      mergeMap(() => {
        return [
          PriceFilteringAction.update.done({ params }),
        ];
      }),
      catchApiError((error) => {
        const isHandled = reject?.(error.errorCode, error.description, error.params);
        return [
          PriceFilteringAction.update.failed({ params, error }),
          ...(isHandled ? [] : [createApiErrorNotification(error)]),
        ];
      }),
    );
  }),
);
